<template>
  <div class="capusta-container" :class="{ [containerSize]: true }">
    <slot />
  </div>
</template>

<script>
import { inArray } from 'lib/component/validators';

export default {
  name: 'CapustaContainer',
  props: {
    containerSize: {
      type: String,
      validator: inArray(['small', 'medium', 'large']),
      default() {
        return 'medium';
      },
    },
  },
};
</script>

<style lang="sass" scpoed>
  .capusta-container
    width: 100%
    position: relative
    margin: 0 auto
    display: flex
    flex-direction: column
    padding: 20px 0 60px

    +respond-to("medium")
      padding: 60px 0

      &.large
        width: 940px

      &.medium
        width: 640px

      &.small
        width: 480px
</style>
